import React, {useEffect, useState} from 'react';
import {Accordion} from '../Accordion/LocalizedAccordion';
import {t} from 'i18next';
import {DropdownInput, LocaleSelection} from './LocalePicker.style';
import {Locale} from './resources/LocaleResource';
import {isNullOrEmpty} from '../../utils';

export interface LocalePickerProps {
    readonly dataSource: string[];
    readonly defaultValue: string;
    readonly resetState: boolean;
    readonly resetInput: boolean;
    readonly disabled: boolean;
    onChange: (localeSelection: string[]) => void;
}

export const LocalePicker: React.VFC<LocalePickerProps> = (props) => {
    const getOptions = (localeSelectionState: string[]) => {
        let options: Locale[] = [];
        let localeItem: Locale = {name: 'Select Locale', value: ''};
        options.push(localeItem);
        props.dataSource.filter(locale => ((isNullOrEmpty(locale)) || (!localeSelectionState.includes(locale)))).map(locale => {
            localeItem = {name: locale, value: locale}
            options.push(localeItem);
        });

        return options;
    };

    const getLocaleSelection = (localeSelectionState: string[]) => {
        let localeSelection: string[] = [];
        let localeItem: string[] = [];
        if (localeSelectionState) {
            localeSelectionState.map(locale => {
                if (locale) {
                    localeItem = locale.split('/');
                    if ((localeItem) && (localeItem.length >= 3)) {
                        localeSelection.push(localeItem[1].toLowerCase().concat('_').concat(localeItem[2].toUpperCase()));
                    }
                }
            });
        }

        return localeSelection;
    };

    const [localeSelection, setLocaleSelection] = useState<string[]>([]);
    const [localeInput, setLocaleInput] = useState<string>(props.defaultValue ? props.defaultValue : '');
    const [localeOptions, setLocaleOptions] = useState<Locale[]>(getOptions([]));

    const setState = (selectionState: string[], selectionOptions: Locale[], resetInput: boolean) => {
        setLocaleSelection(selectionState);
        props.onChange(getLocaleSelection(selectionState));
        setLocaleOptions(selectionOptions);
        if (resetInput) {
            setLocaleInput('');
        }
    };

    useEffect(() => {
        if (props.resetState) {
            setState([], getOptions([]), true);
        }
    }, [props.resetState]);

    const handleInput = (e: React.ChangeEvent<HTMLSelectElement>) => {
        let eventValue = e.target.value.toString();
        setLocaleInput(eventValue);
        let selectionOptions = localeOptions;
        let selectionState = [eventValue];
        if (props.resetInput) {
            selectionOptions = localeOptions.filter(locale => (locale.value !== eventValue));
            selectionState = [...localeSelection];
            if (!localeSelection.includes(eventValue)) {
                selectionState = selectionState.concat(eventValue);
            }
        }
        setState(selectionState, selectionOptions, props.resetInput);
    };

    const handleDelete = (localeKey: string) => {
        let selectionState = localeSelection.filter(locale => (locale !== localeKey));
        setState(selectionState, getOptions(selectionState), true);
    };

    const getLabel = (locale: string) => {
        let label = '';
        if (locale) {
            label = locale;
        }

        return label;
    };

    return (
        <Accordion localizedHeadline={t('LOCALE_PICKER_CAPTION')}>
            <DropdownInput
                id={'localeId_'.concat(localeInput)}
                defaultValue={props.defaultValue ? props.defaultValue : ''}
                value={localeInput}
                options={localeOptions}
                disabled={props.disabled}
                onChange={handleInput}
            />
            {localeSelection?.map(locale => {
                return props.resetInput &&
                    <LocaleSelection key={locale} label={getLabel(locale)} buttonClose
                                     onClose={() => handleDelete(locale)}/>;
            })}
        </Accordion>
    );
};
